import { render, staticRenderFns } from "./assignment_card.vue?vue&type=template&id=83c16caa&scoped=true&"
import script from "./assignment_card.vue?vue&type=script&lang=js&"
export * from "./assignment_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c16caa",
  null
  
)

export default component.exports